import React from 'react';
import { Label } from '../Label';
export const PromoLabel = ({ discount }) => (React.createElement(Label, { backgroundColor: "lightBlue600", padding: "2px 4px" }, `-${discount}%`));
